import moment from 'moment'

/** Primeiros 10 caracteres como data local `YYYY-MM-DD` (evita deslocar por ISO com `Z`). */
export function parseAgendaDateOnly(raw) {
  if (raw == null || raw === '') return moment.invalid()
  const s = String(raw).trim()
  const d = s.length >= 10 ? s.slice(0, 10) : s
  if (/^\d{4}-\d{2}-\d{2}$/.test(d)) {
    return moment(d, 'YYYY-MM-DD', true)
  }
  return moment.invalid()
}

/**
 * Momento local de ancoragem para recorrência WEEKLY: data em `start_recur` se existir, senão data de `start`;
 * hora de `start_time` (ou de `start` se for datetime válido).
 */
export function weeklySeriesAnchorMoment(e) {
  const hasRecur = e.start_recur != null && String(e.start_recur).trim() !== ''
  let day = hasRecur ? parseAgendaDateOnly(e.start_recur) : parseAgendaDateOnly(e.start)
  if (!day.isValid()) {
    day = moment(e.start).clone().startOf('day')
  }
  const timeRaw = e.start_time != null && String(e.start_time).trim() !== ''
    ? e.start_time
    : e.start
  const t = moment(timeRaw, [moment.ISO_8601, 'HH:mm:ss', 'H:mm:ss'], true)
  if (!t.isValid()) {
    const fallback = moment(e.start)
    if (fallback.isValid()) {
      return day.clone().hour(fallback.hour()).minute(fallback.minute()).second(fallback.second()).millisecond(0)
    }
    return day
  }
  return day.clone().hour(t.hour()).minute(t.minute()).second(t.second()).millisecond(0)
}

/** `end` no mesmo dia de `startInput`, usando `end_time` (HH:mm:ss). Evita fim inválido antes do início. */
export function agendaEndOnStartDayIso(startInput, endTimeStr) {
  const startM = moment(startInput)
  if (!startM.isValid()) return moment().format('YYYY-MM-DDTHH:mm:ss')
  if (!endTimeStr) return startM.clone().add(1, 'hour').format('YYYY-MM-DDTHH:mm:ss')
  const parts = String(endTimeStr).trim().split(':')
  const h = parseInt(parts[0], 10) || 0
  const mi = parseInt(parts[1], 10) || 0
  const s = parseInt(parts[2], 10) || 0
  const endM = startM.clone().startOf('day').hours(h).minutes(mi).seconds(s)
  if (!endM.isAfter(startM)) endM.add(1, 'day')
  return endM.format('YYYY-MM-DDTHH:mm:ss')
}
